import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _path3 from "path";
import _universalImport3 from "babel-plugin-universal-import/universalImport";
import _path2 from "path";
import _universalImport2 from "babel-plugin-universal-import/universalImport";
import _path from "path";
import _universalImport from "babel-plugin-universal-import/universalImport";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import { MARKETPLACE, MARKETPLACE_NAMED_QUERIES, WORDPRESS } from './types/providers'; // returns a providers map for nerdwallet-specific configured providers

export default function createNerdwalletProviders() {
  var _ref;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nwApiSdk = options.nwApiSdk,
      appConfig = options.appConfig,
      schema = options.schema,
      serverRequest = options.serverRequest; // TODO: modularize this options checking so it can be reused by native version of this file

  if (!nwApiSdk) throw new Error('`nwApiSdk` required to createNerdwalletProviders');
  if (!appConfig) throw new Error('`appConfig` required to createNerdwalletProviders');
  return _ref = {}, _defineProperty(_ref, MARKETPLACE, function () {
    return _universalImport({
      id: "./providers/marketplace",
      load: function load() {
        return Promise.all([import(
        /* webpackChunkName: 'providers/marketplace' */
        './providers/marketplace')]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return _path.join(__dirname, './providers/marketplace');
      },
      resolve: function resolve() {
        return require.resolveWeak('./providers/marketplace');
      },
      chunkName: function chunkName() {
        return "providers/marketplace";
      }
    }).then(function (module) {
      return module.default({
        nwApiSdk: nwApiSdk,
        appConfig: appConfig,
        serverRequest: serverRequest
      });
    });
  }), _defineProperty(_ref, MARKETPLACE_NAMED_QUERIES, function () {
    return _universalImport2({
      id: "./providers/marketplace-named-queries",
      load: function load() {
        return Promise.all([import(
        /* webpackChunkName: 'providers/marketplace-named-queries' */
        './providers/marketplace-named-queries')]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return _path2.join(__dirname, './providers/marketplace-named-queries');
      },
      resolve: function resolve() {
        return require.resolveWeak('./providers/marketplace-named-queries');
      },
      chunkName: function chunkName() {
        return "providers/marketplace-named-queries";
      }
    }).then(function (module) {
      return module.default({
        nwApiSdk: nwApiSdk,
        appConfig: appConfig,
        serverRequest: serverRequest
      });
    });
  }), _defineProperty(_ref, WORDPRESS, function () {
    return _universalImport3({
      id: "./providers/wordpress",
      load: function load() {
        return Promise.all([import(
        /* webpackChunkName: 'providers/wordpress' */
        './providers/wordpress')]).then(function (proms) {
          return proms[0];
        });
      },
      path: function path() {
        return _path3.join(__dirname, './providers/wordpress');
      },
      resolve: function resolve() {
        return require.resolveWeak('./providers/wordpress');
      },
      chunkName: function chunkName() {
        return "providers/wordpress";
      }
    }).then(function (module) {
      return module.default({
        nwApiSdk: nwApiSdk,
        appConfig: appConfig,
        schema: schema,
        serverRequest: serverRequest
      });
    });
  }), _ref;
}